// extracted by mini-css-extract-plugin
module.exports = {"row":"ClientNote_row__s8kUZ","nameDateColumn":"ClientNote_nameDateColumn__3sP7M","note":"ClientNote_note__1J5mZ","linkContainer":"ClientNote_linkContainer__2GjDj"};